module.exports = __webpack_public_path__ + "static/media/front_back_white.ad41e393.png";